import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ProvedorAutenticacao } from './context/autenticacao_contexto';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ProvedorAutenticacao>
      <App />
    </ProvedorAutenticacao>
  </React.StrictMode>
);